export type ProductKeyTypes =
    | "confluence"
    | "confluence-PaidLpConflDocumentation"
    | "confluence-PaidLpConflFeatures"
    | "confluence-PaidLpConflFeaturesCerebro"
    | "confluence-PaidLpConflTemplate"
    | "confluence-AnchorLpConfCollaboration"
    | "customers"
    | "home"
    | "jira"
    | "jiraServiceDesk"
    | "jiraServiceManagement"
    | "jiraProductDiscovery"
    | "jiraServiceManagement-PaidLpJsmFeatures"
    | "jiraServiceManagement-PaidLpJsmFeaturesCerebro"
    | "jiraServiceManagement-PaidLpJsmIncidentChangeMgmt"
    | "jiraServiceManagement-PaidLpJsmItsm"
    | "jiraServiceManagement-PaidLpJsmServiceDesk"
    | "jiraServiceManagement-PaidLpJsmTicketing"
    | "jiraServiceManagement-AnchorLpJsmAsset"
    | "jiraServiceManagement-AnchorLpJsmDevops"
    | "jiraSoftware"
    | "jiraSoftware-PaidLpJiraFeatures"
    | "jiraSoftware-PaidLpJiraPm"
    | "jiraSoftware-PaidLpJiraRoadmaps"
    | "jiraSoftware-PaidLpJiraTemplate"
    | "jiraSoftware-PaidLpJiraTracker"
    | "jiraSoftwareFeature"
    | "enterprise"
    | "enterpriseContactSales"
    | "enterpriseContactThanks"
    | "try"
    | "404"
    | "bitbucket"
    | "trello"
    | "opsgenie"
    | "jiraWorkManagement"
    | "jiraAlign"
    | "atlassianAccess"
    | "support"
    | "bamboo"
    | "crowd";

type CommonComponentsTypes =
    | "linkButton"
    | "tab"
    | "card"
    | "carouselItem"
    | "link";

type CommonContainersTypes =
    | "navbarDropdown"
    | "navbar"
    | "globalNavWacDropdownContainer"
    | "globalFooterV2"
    | "heroSection"
    | "cardSection"
    | "ctaSection"
    | "announcementBanner"
    | "priceBlock"
    | "priceBlockDropdownLocalized"
    | "infographicsSection"
    | "freeBundles"
    | "customersSection"
    | "getTheMostSection"
    | "productSelector";

type CommonEventTypes = "clicked" | "hovered" | "loading";

type JSWContainerTypes =
    | CommonContainersTypes
    | "featuresSection"
    | "benefitsSection"
    | "banner-link-button"
    | "priceBlock"
    | "pricingQuiz"
    | "priceBlockDropdownLocalized"
    | "devOpsSection"
    | "integrationSection"
    | "workflowSection"
    | "pronouncedCtaSection"
    | "timelineSection"
    | "reportsAndInsightsSection"
    | "dragAndDropSection";

type JSMContainerTypes =
    | CommonContainersTypes
    | "benefitsSection"
    | "featuresSection"
    | "integrationsSection"
    | "videoEmbedInline"
    | "linkButton"
    | "videoLink";

type ConfluenceContainerTypes =
    | CommonContainersTypes
    | "priceBlock"
    | "featuresSection"
    | "benefitsSection"
    | "additionalResourcesSection"
    | "videoEmbedInline"
    | "videoLink"
    | "integrationsSection"
    | "mobileSection"
    | "resourcesSection"
    | "templatesSection"
    | "templatesTabCard"
    | "testimonialsSection";

export type DataEventProps =
    | {
          "data-product-key": Extract<
              ProductKeyTypes,
              | "confluence"
              | "confluence-PaidLpConflDocumentation"
              | "confluence-PaidLpConflFeatures"
              | "confluence-PaidLpConflTemplate"
          >;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": ConfluenceContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<
              ProductKeyTypes,
              | "home"
              | "jiraSoftware-PaidLpJiraFeatures"
              | "jira"
              | "try"
              | "enterprise"
              | "enterpriseContactSales"
              | "enterpriseContactThanks"
          >;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": CommonContainersTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<
              ProductKeyTypes,
              "jiraSoftware" | "jiraSoftwareFeature" | "jiraProductDiscovery"
          >;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSWContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<ProductKeyTypes, "jiraServiceDesk">;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSMContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<ProductKeyTypes, "jiraServiceManagement">;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSMContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": ProductKeyTypes;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": CommonContainersTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      };
